import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import axios from "axios";

const fetchMerchantOrders = async (token) => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/order/orders/merchant/me`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.orders;
};

const useMerchantOrders = () => {
  const { token, isLoggedIn } = useContext(AuthContext);

  return useQuery("merchantOrders", () => fetchMerchantOrders(token), {
    enabled: !!token && isLoggedIn,
  });
};

export default useMerchantOrders;
